/*faq*/
const Index = () => import(/* webpackChunkName: "group-faq" */ '../view/faq/Index.vue');
const Detail = () => import(/* webpackChunkName: "group-faq" */ '../view/faq/Detail.vue');
const Protocol = () => import(/* webpackChunkName: "group-faq" */ '../view/faq/Protocol.vue');

export default [
    {
        path: '/faq',
        name: 'faq',
        component: Index,
        meta: {
            title: '【旋涡营销】帮助中心'
        }
    },
    {
        path: '/faq-detail/:itemId',
        name: 'faq-detail',
        component: Detail,
        meta: {
            title: '【旋涡营销】帮助中心'
        }
    },
    {
        path: '/faq-protocol',
        name: 'faq-protocol',
        component: Protocol,
        meta: {
            title: '【旋涡营销】服务协议'
        }
    }
]



// WEBPACK FOOTER //
// ./app/router/router-faq.js